export enum ListType {
  Common = 'common',
  Metrics = 'metrics',
  Custom = 'custom',
  MatchItem = 'match-item',
  Players = 'players',
  Simple = 'simple'
}

export enum GroupTitle {
  Date = 'date'
}

export interface List<T> {
  type: ListType
  header?: ListHeader
  groups: ListGroup<T>[]
}

export interface ListGroup<T> {
  title?: string
  titleType?: GroupTitle
  extraClasses?: string
  items: T[]
}

export interface ListHeaderContent {
  img: string
  title?: string
  subtitle?: string
  subtitleExtra?: string
  isPlayer?: boolean
}

export interface ListAggregationMiddleHeader {
  text?: string
  icon?: string
}

export interface ListHeader {
  leftContent: ListHeaderContent
  rightContent: ListHeaderContent
  isSwitchable?: boolean
  switcherValues?: { id: string; text: string }[]
  aggregation?: ListAggregationMiddleHeader
}

export interface CommonListItem {
  text: string
  subtext?: string
  icon?: string
  actionIcon?: string
  localIcon?: string
  navigateUrl?: string
  qaId?: string
  attributes?: { [key: string]: any }
}

export interface MetricListItem {
  text: string
  homeValue: string
  awayValue: string
  homeDecorated?: boolean
  awayDecorated?: boolean
  homeUnit?: string
  awayUnit?: string
  navigateUrl?: string
  qaId?: string
  attributes?: { [key: string]: any }
}

export interface PlayerListItem {
  imgUrl: string
  shirtNumber: number
  name: string
  position: string
  navigateUrl?: string
  qaId?: string
  id?: string
  isSelectable?: boolean
  teamShield?: string
  teamName?: string
  imgAlt?: string
  attributes?: { [key: string]: any }
}

export interface SimpleListItem {
  id: string
  text: string
  isSelectable?: boolean
  attributes?: { [key: string]: any }
}
